
import $ from 'jquery';
require('@bower_components/jquery-sortable/source/js/jquery-sortable.js');

export default function () {
  var adjustment;

  function reLabelFields(parent) {
    var parentName = parent.attr('id');
    parent.find('.inline-field').each(function (index) {
      var fields = $(this);

      // reset all field names and ids
      // schema: <model>-<index>-<fieldname>
      fields.find('.inline-form-field').find(
        'input[name^="' + parentName + '"], textarea[name^="' + parentName + '"]' +
        ', select[name^="' + parentName + '"]'
      ).each(
        function () {
          var name = $(this).attr('name').match(/([^-]+)$/)[0];
          var fieldName = parentName + '-' + index + '-' + name;
          $(this).attr({
            id: fieldName,
            name: fieldName
          });
        }
      );

      // reset all for-attributes on <label> to the ids from above
      fields.find('.inline-form-field label').each(function () {
        var name = $(this).attr('for').match(/([^-]+)$/)[0];
        var fieldName = '#' + parentName + '-' + index + '-' + name;
        $(this).attr({
          for: fieldName
        });
      });
    });
  }

  function disableUnusableButtons(parent) {
    var upButtons = parent.find('.inline-field-move-up');
    var downButtons = parent.find('.inline-field-move-down');

    upButtons.removeAttr('disabled').first().attr('disabled', 'disabled');
    downButtons.removeAttr('disabled').last().attr('disabled', 'disabled');
  }

  $('.inline-field-list').sortable({
    containerSelector: '.inline-field-list',
    // itemPath: '> tbody',
    itemSelector: '.inline-field',
    //group: '.inline-field-list',
    handle: '.inline-field-dragpoint',
    placeholder: '<div class="inline-field well well-sm" />',
    onDragStart: function ($item, container) {
      $item.addClass(container.group.options.draggedClass);
      $("body").addClass(container.group.options.bodyClass);
      $item.css('width', $item.outerWidth());
      $item.css('height', $item.outerHeight());

      var offset = $item.offset(),
        pointer = container.rootGroup.pointer;

      adjustment = {
        left: pointer.left - offset.left,
        top: pointer.top - offset.top
      };
    },
    onDrag: function ($item, position) {
      $item.css({
        left: position.left - adjustment.left,
        top: position.top - adjustment.top
      });
    },
    onDrop: function ($item, container, _super) {
      _super($item, container);
      reLabelFields(container.el.parent());
      disableUnusableButtons(container.el);
    }
  });

  function swapNodes(a, b) {
    var aparent = a.parentNode;
    var asibling = a.nextSibling === b ? a : a.nextSibling;
    b.parentNode.insertBefore(a, b);
    aparent.insertBefore(b, asibling);
  }

  $('.inline-field-move').on('click', function (event) {
    event.preventDefault();
    var btn = $(this);
    var field = btn.parents('.inline-field:eq(0)');
    var other = false;

    if (btn.is('.inline-field-move-up')) {
      var prev = field.prev();
      if (prev.length) {
        other = prev;
      }
    } else {
      var next = field.next();
      if (next.length) {
        other = next;
      }
    }

    if (other) {
      swapNodes(field[0], other[0]);
      reLabelFields(field.parents('.inline-field'));
      disableUnusableButtons(field.parents('.inline-field'));
    }
  });

  $('.inline-field-list').on('click', '.inline-field-delete', function (event) {
    // event.stopPropagation();
    var button = $(this);
    var fieldSet = button.parents('.inline-field').first().find('.inline-form-field');
    var stateField = button.find('input');
    var previousState = stateField.prop('checked');
    var text;

    if (previousState) {
      text = button.data('off-text');
      fieldSet.show('slow');
    } else {
      text = button.data('on-text');
      fieldSet.hide('slow');
    }

    // set new state
    stateField.prop('checked', !previousState);
    button.find('span').text(text);
  });

  disableUnusableButtons($('.inline-field-list'));
}
